import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isLogin } from '../../../helpers/authentication';
import { loginPage } from '../../../router/routes';

const PrivateRoute = () => (isLogin() ? <Outlet /> : <Navigate to={loginPage} />);

export default PrivateRoute;
